import { render, staticRenderFns } from "./indexMenu.vue?vue&type=template&id=62bd2fbf&"
import script from "./indexMenu.vue?vue&type=script&lang=js&"
export * from "./indexMenu.vue?vue&type=script&lang=js&"
import style0 from "./indexMenu.vue?vue&type=style&index=0&id=62bd2fbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports